<script setup lang="ts">
/**
 * @author Alexander Kenchoshvili, Giorgi Tseradze
 */

//
import { useMainStore } from "@/store/main/index";
import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperOptions } from "./ts/swiper";
import "swiper/css";
import BoxArrow from "@/components/regularComponents/UIComponents/SVG/actions/BoxArrow.vue";
import { SecondaryDataInterface } from "@/types/ContentType";
import Gallery from "../Gallery/Gallery.vue";
import { Ref, ref, computed } from "vue";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  contentData: SecondaryDataInterface | undefined;
}>();

const mainStore = useMainStore();

const isDesktop = computed(() => mainStore.windowWidth >= mainStore.breakpoints.mobile);

const data = props?.contentData?.data?.list[0];

const images = props?.contentData?.data?.list?.[0]?.image;

const currentImage: Ref<number> = ref(0);
const activeModal: Ref<boolean> = ref(false);

const modalEvent = (e: boolean, index: number): void => {
  currentImage.value = index;
  activeModal.value = e;
};
</script>

<template>
  <div class="infrastructure pos-rel">
    <teleport to="body">
      <Transition name="fade">
        <Gallery
          v-if="activeModal"
          @close="modalEvent(false, 0)"
          :isOpen="isDesktop"
          :currentImages="currentImage"
          :data="images"
          :imgTitle="data?.title"
          :imageStyle="false"
        />
      </Transition>
    </teleport>

    <div class="infrastructure__items">
      <div v-if="contentData?.conf?.header" class="infrastructure__title">
        <h2 class="hl-1-plus uppercase">{{ contentData?.conf?.header?.title }}</h2>
      </div>
      <div class="infrastructure__cards d-flex">
        <div v-if="contentData?.data?.list?.[0]?.teaser" v-html="contentData?.data?.list?.[0]?.teaser" class="infrastructure__info p-16">
        </div>
        <Swiper
          ref="carouselRef"
          :grab-cursor="true"
          :watchOverflow="true"
          :slides-per-view="'auto'"
          :space-between="swiperOptions.spaceBetween"
          :breakpoints="swiperOptions.breakpoints"
          :options="swiperOptions"
        >
          <SwiperSlide v-for="(item, index) in data?.image" :key="index">
            <div class="infrastructure__card w-full">
              <div
                class="infrastructure__image-wrapper pos-rel w-full"
                @click="modalEvent(true, index)"
              >
                <Picture
                  :devices="item?.devices"
                  imgClass="img-absolute"
                  :alt="data?.title"
                />
                <div class="infrastructure__arrow-wrapper pos-abs">
                  <div class="infrastructure__icon-wrapper d-flex j-center al-center">
                    <BoxArrow class="infrastructure__arrow-icon" />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<style src="./styles/Infrastructure.scss"></style>
